// import { useEffect, useRef } from 'react';
import classNames from 'classnames';
import Split from 'react-split';
import {useDrop} from 'react-dnd';


import { Fragment } from 'react';
import { useDragAndDrop } from '@/utils/useDragAndDrop';
import { IMainContent, IObjNumber } from '@/utils/ctype';
import { isArticleTitle } from '@/utils/articleTitle';
import GroupTitle from '@/pages/Mock/components/GroupTitle';
import { getArticleImageHeight } from '@/utils/articleImageSize';
import ScrollBody from '../../../components/ScrollBody';
import PartTitle from '../../../components/PartTitle';
import Group from '../Group';
import Drag from '../../../components/Drag';
import Drop from '../../../components/Drop';
import SubTitle from '../../../components/SubTitle';
import HtmlParser from '../../../components/HtmlParser';
import style from './index.module.less';
import './index.less';

export default function MainContent(props: IMainContent) {

  
  const {question = [], pageData, currentFocus = 0, saveAnswerHandle, answerMap, loadAnswered, isAI, 
    displayAnswerMap,
    boxStyle, index, showDragField, setShowDragFieldHandle, setFocusIndexHandle} = props;

  const {content} = pageData.question;

  const {paragraph, order_ary, order_aryHtml, title, sub_title, paragraph_title, paragraph_img, notes} = content;
  const titleData = question.find((item) => item.type === 6);

  const {
    dustbins,
    boxes,
    recoverOption,
    recoverBlank,
    handleDrop,
    handleDropOptionList
  } = useDragAndDrop(titleData, {optionHidden: 'remove', type: 'subTitle', accepts: ['subTitle', 'subBlank'], blankType: 'subBlank', saveAnswerHandle, pageData, loadAnswered, answerMap});

  const indexToCodeMap = dustbins.reduce((memo: IObjNumber, item, index) => {
    const {data} = item;
    const { sub_essay_code} = data;
    memo[sub_essay_code] = index;
    return memo;
  }, {} );


  const createDrop = (key: string) => {
    if (!titleData || !titleData.list) {
      return null;
    }

    const index = indexToCodeMap[key];
    if (titleData && index !== undefined && dustbins[index] && dustbins[index].data.sub_essay_code === key) {
      const {data, accepts, lastDroppedItem, type, uid} = dustbins[index];
      return (
        <Drop
          accept={accepts}
          lastDroppedItem={lastDroppedItem}
          onDrop={(item) => handleDrop(index, item)}
          index={index}
          data={data}
          recoverOption={recoverOption}
          recoverBlank={() => recoverBlank(index)}
          type={type}
          blankBoxClass={style.blankBoxClass}
          blankClass={style.blankClass}
          id={`question${data.number}`}
          uid={uid}
          onFocus={() => {setFocusIndexHandle&&setFocusIndexHandle(data.number);}}
        />
      );
    } 
  };

  const [{ isOver, canDrop }, drop] = useDrop({
    accept: ['subTitle', 'subBlank'],
    drop: handleDropOptionList,
    collect: (monitor) => ({
      isOver: monitor.isOver(),
      canDrop: monitor.canDrop(),
    }),
  });

  return (
    <div className={style.exercises} style={boxStyle}>
      <Split gutterSize={2} className={style.writingBox} dragInterval={1}>
        <div className={classNames(style.articleBox)} id={`article${index}`}>
          {title ? <div className={style.title} data-key={'question.content.title'}>
            <HtmlParser htmlString={title}></HtmlParser>
          </div> : null}
          {sub_title ? <div className={style.subTitle} data-key={'question.content.sub_title'}>
            {
              sub_title.split('\n').map((s, i) => {
                return <div key={i}><HtmlParser htmlString={s}></HtmlParser></div>;
              })
            }
          </div> : null}
          {
            !!content.image && typeof content.image === 'string' ? <div className={style.img}><img src={content.image} style={{ maxHeight: getArticleImageHeight(content.image) }} /></div> : null
          }

          {
            !!content['pre-A'] ? <>
              {
                (content['pre-A'] as string).split('\n').map((s, i) => {
                  return <p key={`pre_${index}_${i}`} className={style.content} data-key={`question.content.pre.${i}`}><HtmlParser htmlString={s}></HtmlParser>
                  </p>;
                })
              }
            </> : null
          }

          {
            order_ary ? order_ary.map((key: string, index: number) => {
              return (
                <div key={index}>
                  {
                    paragraph_title && paragraph_title[order_aryHtml[index]] ? <>
                      <p className={style.letter} data-key={`~question.content.order_ary.${index}`}><HtmlParser htmlString={paragraph_title[order_aryHtml[index]]}></HtmlParser></p>
                    </> : <>
                      <p className={style.letter} data-key={`~question.content.order_ary.${index}`}><HtmlParser htmlString={order_aryHtml[index]}></HtmlParser></p>
                    </>
                  }
                  {createDrop(key)}
                  <p key={`${index}`} className={style.content} data-key={`question.content.${key}`}>
                    {
                      (content[key] as string).split('\n').map((s, i) => {
                        return <div key={`${index}_${i}`} className={style.content}><HtmlParser htmlString={s}></HtmlParser>
                        </div>;
                      })
                    }
                  </p>
                </div>
              ); 
            }) :
              null
          }
          {
            paragraph ? paragraph.map((str: string, index: number) => {
              const img = paragraph_img ? paragraph_img.find((ele) => ele.paragraph === index) : null;
              return <Fragment key={index}>
                <p className={style.content} key={index} data-key={`question.content.paragraph.${index}`}>
                  {
                    str.split('\n').map((s, i) => {
                      const b = isArticleTitle(s);
                      return <div className={classNames(style.content, b ? style.contentBold : '')} key={`${index}_${i}`}>
                        <HtmlParser htmlString={s}></HtmlParser>
                      </div>;
                    })
                  }
                </p>

                {
                  img ? <div className={style.img}><img src={img.img_url}  style={{ maxHeight: getArticleImageHeight(img.img_url) }} /></div> : null
                }
              </Fragment>;
            }) : null
          }
          {
            notes && notes.length > 0 ? <div className={style.notes}>
              {notes.map((note, i) => (
                <p key={i} className={style.noteItem}><HtmlParser htmlString={note}></HtmlParser></p>
              ))}
            </div> : null
          }
        </div>
        <ScrollBody show={showDragField} className={style.answer} scrollViewClass={style.viewBox}>
          {
            question.map((item, index: number) => {
              return item.type !== 6 ? <Group displayAnswerMap={displayAnswerMap} data={item} index={index} key={index} currentFocus={currentFocus} saveAnswerHandle={saveAnswerHandle}
                answerMap={answerMap} pageData={pageData} loadAnswered={loadAnswered} isAI={isAI}
                setShowDragFieldHandle={setShowDragFieldHandle}
                setFocusIndexHandle={setFocusIndexHandle}></Group> : 
                <div key={index} className={style.answerList}>
                  <SubTitle desc={titleData!.desc} keyIndex={index} staticWidth></SubTitle>
                  
                  <div className={classNames(style.answerListBox, isOver ? style.isOver : '')} ref={drop}>
                    {
                      titleData && titleData.title ? <GroupTitle title={titleData?.title} /> : null
                    }
                    {
                      boxes.map(({data, type, display, optionHidden, uid}, boxIndex) => {
                        return <Drag data={data} type={type} key={index} index={boxIndex} display={display} optionHidden={optionHidden} optionClass={style.mt15} uid={uid} setShowDragFieldHandle={setShowDragFieldHandle}/>;
                      })
                    }
                  </div>
                </div>;
            })
          }
        </ScrollBody>
          
      </Split>
      
    </div>
  );
  
}